import React, { Component } from 'react';
import history from '../../services/history';

export class Callback extends Component {
  render() {
    return (
      <div>
        logged in...
      </div>
    );
  }
}